import React from 'react'
import './style.scss'

interface Props {
    onClick: (e: any) => void,
    children: React.ReactNode,
    disabled?: boolean,
    filled?: boolean,
    negative?: boolean,
    light?: boolean,
    highlight?: boolean,
    small?: boolean
}

const ButtonCircle: React.FC<Props> = ({onClick, children, disabled, filled, negative, light, highlight, small}) => {
    return (
        <button className={`
        buttonCircle 
        ${filled ? "buttonCircle--filled" : ""} 
        ${negative ? "buttonCircle--negative" : ""}
        ${light ? "buttonCircle--light" : ""}
        ${highlight ? "buttonCircle--highlight" : ""}
        ${small ? "buttonCircle--small" : ""}
        `} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    )
}

export default ButtonCircle
